/* 101Passports merch page behavior, 2026-10-14. Shows the right options, caps the icon picks, and blocks add to cart until the customization is complete. */
(function(){
  document.querySelectorAll('.pp-merch').forEach(function(root){
  var form=root.querySelector('form[action*="/cart/add"]');
  var maxIcons=parseInt(root.getAttribute('data-max-icons'),10)||4;

  var main=root.querySelector('#pp-main-img');
  root.querySelectorAll('.thumbs button').forEach(function(t){t.addEventListener('click',function(){
    if(main){main.src=t.getAttribute('data-src');main.removeAttribute('srcset');}
    root.querySelectorAll('.thumbs button').forEach(function(o){o.setAttribute('aria-current',o===t?'true':'false');});});});

  var vsel=root.querySelector('[data-variant-select]');
  if(vsel){vsel.addEventListener('change',function(){
    var p=vsel.options[vsel.selectedIndex].getAttribute('data-price');
    var pe=root.querySelector('#pp-price');if(pe&&p)pe.textContent=p;
    var mp=root.querySelector('#pp-mprice');if(mp&&p)mp.textContent=p;});}

  if(!form){return;}
  var err=form.querySelector('[data-error]');
  var panels={};
  form.querySelectorAll('[data-panel]').forEach(function(p){panels[p.getAttribute('data-panel')]=p;});

  function setPanel(p,on){
    if(!p)return;
    p.hidden=!on;
    p.querySelectorAll('input,select').forEach(function(f){f.disabled=!on;if(!on){if(f.type==='checkbox'){f.checked=false;}else{f.value='';}}});
  }
  // Hidden panels start disabled so nothing unselected rides along to the cart.
  Object.keys(panels).forEach(function(k){setPanel(panels[k],false);});

  form.querySelectorAll('[data-art]').forEach(function(r){r.addEventListener('change',function(){
    var kind=r.getAttribute('data-art');
    setPanel(panels.skyline,kind==='skyline');
    setPanel(panels.icons,kind==='icons');
    countIcons();hideError();});});

  function pickedIcons(){return Array.prototype.filter.call(form.querySelectorAll('[data-icon]'),function(c){return c.checked;});}
  function countIcons(){
    var n=pickedIcons().length,label=form.querySelector('[data-icon-count]');
    if(label)label.textContent='('+n+' picked)';
    form.querySelectorAll('[data-icon]').forEach(function(c){if(!c.closest('[hidden]'))c.disabled=(!c.checked&&n>=maxIcons);});
  }
  form.querySelectorAll('[data-icon]').forEach(function(c){c.addEventListener('change',function(){countIcons();hideError();});});

  var tsel=form.querySelector('[data-text-select]');
  var cinput=form.querySelector('[data-custom-input]');
  if(tsel){tsel.addEventListener('change',function(){
    var custom=tsel.options[tsel.selectedIndex].hasAttribute('data-custom');
    setPanel(panels.customtext,custom);
    if(custom&&cinput)cinput.focus();
    hideError();});}
  if(cinput){cinput.addEventListener('input',function(){
    // The typed text becomes the Text property, so the order reads "Text: Deep Ellum".
    var opt=tsel.querySelector('[data-custom]');
    if(opt)opt.value=cinput.value.trim()||'__custom';});}

  function showError(m){if(!err)return;err.textContent=m;err.hidden=false;err.scrollIntoView({block:'center',behavior:'smooth'});}
  function hideError(){if(err)err.hidden=true;}

  form.addEventListener('submit',function(e){
    var colorSel=form.querySelector('[data-required-select]');
    if(colorSel&&!colorSel.value){e.preventDefault();showError('Pick a color first.');return;}
    var art=form.querySelector('[data-art]:checked');
    if(form.querySelector('[data-art]')&&!art){e.preventDefault();showError('Choose your art first: a skyline, icons, or no art.');return;}
    if(art&&art.getAttribute('data-art')==='skyline'){
      var sk=form.querySelector('[data-panel="skyline"] select');
      if(sk&&!sk.value){e.preventDefault();showError('Pick which city skyline you want.');return;}
    }
    if(art&&art.getAttribute('data-art')==='icons'&&pickedIcons().length===0){
      e.preventDefault();showError('Pick at least one icon, or choose a skyline or no art.');return;
    }
    if(tsel&&!tsel.value){e.preventDefault();showError('Choose your text, or pick no text at all.');return;}
    if(tsel&&tsel.value==='__custom'){e.preventDefault();showError('Type the text you want stitched.');return;}
    hideError();
  });
});
})();